import { useMemo } from 'react';
import { useStartKycVerification, useUserData } from '../../queries';
import { useMarketplaceConfig } from '../../queries/marketplace';
import { getCustomerKycDisplayStatus } from '../../utils/kyc';
import useKycAttempts from '../useKycAttempts';
export const useKycVerificationEnabled = (): boolean => {
  const { data: marketplaceConfig } = useMarketplaceConfig();

  return marketplaceConfig?.marketplaceConfig.kyc?.enabled ?? false;
};

export const useKycVerificationAccountSection = () => {
  const { data: userData } = useUserData();
  const { mutate: startVerification, isPending } = useStartKycVerification();
  const { hasReachedLimit } = useKycAttempts(userData?.kycAttempts);

  const displayStatus = getCustomerKycDisplayStatus(userData?.kycStatus);
  const isVerified = displayStatus === 'verified';
  const isInProgress = displayStatus === 'inProgress';

  return useMemo(
    () => ({
      displayStatus,
      hasReachedLimit,
      isInProgress,
      isPending,
      isVerified,
      startVerification,
    }),
    [displayStatus, hasReachedLimit, isInProgress, isPending, isVerified, startVerification]
  );
};
